import { defaultLocale } from "../constants";
import daDK from "../localization/da-DK/strings.json";
import deDE from "../localization/de-DE/strings.json";
import enGB from "../localization/en-GB/strings.json";
import enUS from "../localization/en-US/strings.json";
import esES from "../localization/es-ES/strings.json";
import frFR from "../localization/fr-FR/strings.json";
import itIT from "../localization/it-IT/strings.json";
import laLA from "../localization/la-LA/strings.json";
import nlNL from "../localization/nl-NL/strings.json";
import svSE from "../localization/sv-SE/strings.json";

const allTranslations = {
  daDK,
  deDE,
  enGB,
  enUS,
  esES,
  frFR,
  itIT,
  laLA,
  nlNL,
  svSE,
};

function flatten(obj, out = {}, paths = []) {
  return Object.getOwnPropertyNames(obj).reduce((out, key) => {
    paths.push(key);
    if (typeof obj[key] === "object") {
      flatten(obj[key], out, paths);
    } else {
      out[paths.join(".")] = obj[key];
    }
    paths.pop();
    return out;
  }, out);
}

function normalizeLocale(locale: string) {
  return locale.replace(/-(\w{2})$/, (_, group1) => group1.toUpperCase());
}

export const getTranslations = (locale: string = defaultLocale) => {
  const translations = {
    ...flatten(enUS),
    ...(allTranslations[normalizeLocale(locale)] ? flatten(allTranslations[normalizeLocale(locale)]) : {}),
  };
  return translations;
};
